var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "small_warning_icon",
    "data-name": "small warning icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.642,
    height: 18.691,
    viewBox: "0 0 21.642 18.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M5890,3333.69,5900.82,3315l10.821,18.691Zm2.558-1.475h0Z",
    transform: "translate(-5890 -3315)",
    fill: "#a21110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "warning_FILL0_wght400_GRAD0_opsz48",
    d: "M50.923,191.813a.7.7,0,0,0,.524-.213.726.726,0,0,0,.209-.529.7.7,0,0,0-.213-.524.726.726,0,0,0-.529-.209.7.7,0,0,0-.524.213.726.726,0,0,0-.209.529.7.7,0,0,0,.213.524A.726.726,0,0,0,50.923,191.813Zm-.742-2.73h1.476v-5.509H50.181ZM50.821,186.083Z",
    transform: "translate(-40.181 -175.999)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWarningIcon);
export default __webpack_public_path__ + "static/media/small_warning_icon.20856b6710d87ce03ff7be2d3b91d08d.svg";
export { ForwardRef as ReactComponent };